<ln-menu-wrapper [class]="{ fullscreen: isFullScreen }">
  <router-outlet></router-outlet>
</ln-menu-wrapper>
